export const categories = [
  {
    id: 1,
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-shoes-01",
    prompt: "Modern minimalist sneaker on pure white studio background with soft natural diffused lighting, clean product photography, elegant composition, high-end fashion editorial style, no text no logo, isolated product shot, warm neutral ambient tone",
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    seq: "cat-hoodies-02",
    prompt: "Premium quality casual hoodie floating on pristine white studio backdrop, soft diffused lighting with gentle shadows, clean minimalist product photography, contemporary fashion aesthetic, no visible branding, warm neutral ambiance",
  },
  {
    id: 3,
    name: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    seq: "cat-tshirts-03",
    prompt: "Classic cotton t-shirt photographed on pure white background with soft natural window light, clean minimal product shot, contemporary apparel photography, gentle shadow play, warm cream undertones, no logos visible, editorial quality",
  },
  {
    id: 4,
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    seq: "cat-jackets-04",
    prompt: "Stylish modern jacket presented on clean white studio background with soft directional lighting, elegant product photography, subtle shadow detail, fashion editorial aesthetic, warm neutral color palette, no branding visible, sophisticated composition",
  },
  {
    id: 5,
    name: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    seq: "cat-pants-05",
    prompt: "Tailored casual pants displayed on pristine white studio surface with soft overhead lighting, clean minimalist product photography, contemporary fashion presentation, gentle fabric texture visible, warm atmosphere, no logos or branding",
  },
  {
    id: 6,
    name: "Headwear",
    namePl: "Nakrycia głowy",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    seq: "cat-headwear-06",
    prompt: "Premium baseball cap photographed on pure white studio background with soft natural lighting, clean product shot, modern streetwear aesthetic, subtle shadow definition, warm neutral ambiance, no visible branding, editorial quality",
  },
  {
    id: 7,
    name: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    seq: "cat-sets-07",
    prompt: "Coordinated fashion set arrangement on pristine white studio backdrop with soft diffused lighting, clean elegant product photography, harmonious color coordination, contemporary fashion editorial feel, warm ambient tones, no logos visible",
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    seq: "cat-underwear-08",
    prompt: "Premium cotton underwear displayed on clean white studio background with soft natural lighting, minimalist product photography, elegant simple presentation, gentle fabric texture detail, warm neutral ambiance, no branding visible",
  },
  {
    id: 9,
    name: "Jersey",
    namePl: "Koszulki sportowe",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    seq: "cat-jersey-09",
    prompt: "Athletic sports jersey presented on pure white studio backdrop with soft directional lighting, clean product shot, modern sportswear aesthetic, subtle fabric texture detail, warm neutral tone, no logos visible, editorial quality",
  },
  {
    id: 10,
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    seq: "cat-accessories-10",
    prompt: "Stylish fashion accessories arrangement on pristine white studio background with soft diffused lighting, elegant product photography, clean minimalist composition, warm ambient atmosphere, no visible branding, sophisticated presentation",
  },
  {
    id: 11,
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    seq: "cat-bags-11",
    prompt: "Premium designer bag photographed on pure white studio background with soft natural lighting, clean elegant product photography, contemporary accessories presentation, subtle leather texture visible, warm neutral ambiance, no branding",
  },
  {
    id: 12,
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    seq: "cat-belts-12",
    prompt: "Elegant leather belt displayed on pristine white studio surface with soft directional lighting, clean minimalist product photography, refined accessories presentation, subtle texture detail, warm ambient tone, no logos visible",
  },
  {
    id: 13,
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    seq: "cat-perfumes-13",
    prompt: "Luxury perfume bottle photographed on pure white studio background with soft diffused lighting, elegant product photography, sophisticated minimalist presentation, subtle glass reflection detail, warm neutral ambiance, no branding",
  },
  {
    id: 14,
    name: "OtherStuff",
    namePl: "Inne produkty",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    seq: "cat-other-14",
    prompt: "Assorted fashion accessories collection on pristine white studio backdrop with soft natural lighting, clean elegant product photography, harmonious arrangement, warm ambient atmosphere, no visible branding or logos, sophisticated composition",
  },
];